<template>
  <div v-if="data" class="main-course__wrap">
    <div class="container-padding">
      <div class="main-course">
        <img class="main-course__img" src="/static/images/school_course.png" alt="" />
        <div class="main-course__info">
          <h4 class="main-course__title" v-if="data.title">{{ data.title }}</h4>
          <p class="main-course__description" v-if="data.description">{{ data.description }}</p>
          <button
            @click="$emit('claimCreate', data)"
            type="button"
            class="btn btn--md btn--main btn--with-icon"
          >
            <span>Получить доступ</span>
            <IconComponent name="arrow-right-1" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "MainCourseComponent",
  props: {
    data: Object,
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
.main-course {
  padding-top: 10px
  display: grid
  grid-template-columns: 1fr 1fr
  grid-gap: 35px
  align-items: flex-start
  +below(820px) {
    height: auto
    grid-template-columns: 1fr
    grid-gap: 0
  }

  &__wrap {
    background: var(--gray)
  }

  &__img {
    align-self flex-end
    //height: 455px
    max-height: 100%
    object-fit: contain
    object-position: right bottom
    padding-right: 30px
    +above(821px) {
      height 455px
    }
    +below(820px) {
      max-width: 400px;
      margin: 0 auto;
    }
  }

  &__info {
    display flex
    flex-direction: column
    align-items: flex-start
    gap 20px
    padding 60px 0
    +below(480px) {
      padding: 45px 0
    }
  }

  &__title {
    margin: 0
    font-weight: 700;
    font-size: 1.5em
    line-height: 28px;
  }

  &__description {
    white-space: pre-line
    margin 0
  }
}
</style>
